import React, { Component } from 'react';
import Icon from "../../icon/icon.component.jsx";
import SelectFilter from "./types/selectFilter.component.jsx";
import TextFilter from "./types/textFilter.component.jsx";
import NumberFilter from "./types/numberFilter.component.jsx";
import DateFilter from "./types/dateFilter.component.jsx";
import CustomSelectFilter from "./types/customSelectFilter.component.jsx";
import { injectIntl, defineMessages } from 'react-intl'
import BooleanFilter from './types/booleanFilter.component.jsx';

const messages = defineMessages({
    "isNot": {
        id: "common.search_filter.operation.isNot",
        defaultMessage: "is not",
    },
    "contains": {
        id: "common.search_filter.operation.contains",
        defaultMessage: "contains",
    },
    "doesNotContains": {
        id: "common.search_filter.operation.doesNotContains",
        defaultMessage: "does not contains",
    },
    "startWith": {
        id: "common.search_filter.operation.startWith",
        defaultMessage: "start with",
    },
    "endWith": {
        id: "common.search_filter.operation.endWith",
        defaultMessage: "end with",
    },
    "is": {
        id: "common.search_filter.operation.is",
        defaultMessage: 'is',
    },
    "isNotOneOf": {
        id: "common.search_filter.operation.isNotOneOf",
        defaultMessage: "is not one of",
    },
    "isOneOf": {
        id: "common.search_filter.operation.isOneOf",
        defaultMessage: 'is one of',
    },
    "greaterOrEqualThan": {
        id: "common.search_filter.operation.greaterOrEqualThan",
        defaultMessage: "greater or equal than",
    },
    "greaterThan": {
        id: "common.search_filter.operation.greaterThan",
        defaultMessage: "greater than",
    },
    "lowerOrEqualThan": {
        id: "common.search_filter.operation.lowerOrEqualThan",
        defaultMessage: "lower or equal than",
    },
    "lowerThan": {
        id: "common.search_filter.operation.lowerThan",
        defaultMessage: "lower than",
    },
    "within": {
        id: "common.search_filter.operation.within",
        defaultMessage: "within the last",
    },
    "between": {
        id: "common.search_filter.operation.between",
        defaultMessage: "between",
    },
})

class IndividualFilter extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            filter: props.filter,
            display: false,
            filterTagLabel: props.filterTagLabel,
            filterOperation: props.filterOperation,
            value: props.value,
            isUsed: this.props.isUsed,
            ref: React.createRef()
        }
        this.collapseAction = this.collapseAction.bind(this);
        this.returnFilter = this.returnFilter.bind(this);
        this.manageScroll = this.manageScroll.bind(this)
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.filter) !== JSON.stringify(this.props.filter) || JSON.stringify(prevProps.value) !== JSON.stringify(this.props.value) || prevProps.filterOperation !== this.props.filterOperation) {
            this.setState({
                isUsed: this.props.isUsed,
                value: this.props.value,
                filterOperation: this.props.filterOperation,
                filterTagLabel: this.props.filterTagLabel,
                filter: this.props.filter
            })
        }
    }

    collapseAction() {
        this.setState({ display: !this.state.display })
    }

    isEmpty(value, type, op) {
        if (Array.isArray(value)) {
            return value.length === 0;
        } else if (type === 'date') {
            if (value !== undefined) {
                if (op === 'between' || op === 'within') {
                    return (value.startDate === null && value.endDate === null);
                } else {
                    return value.startDate === null;
                }
            } else {
                return true;
            }
        } else if (type === 'externalLinks') {
            return value.externalId === "";
        } else {
            return value === '' || value == null;
        }
    }

    manageScroll() {
        this.state.ref.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }

    returnFilter() {

        switch (this.props.filter.type) {
            case 'select':
                return (
                    <SelectFilter
                        id={this.state.filter.nameId}
                        type={this.state.filter.typeOfSelect}
                        placeHolder={this.state.filter.placeHolder}
                        filterElement={this.state.filter}
                        op={this.state.filterOperation}
                        value={this.state.value}
                        label={this.state.filterTagLabel}
                        onChangeValues={this.props.onChangeValues}
                    />
                );

            case 'custom-select':
                return (
                    <CustomSelectFilter
                        id={this.state.filter.nameId}
                        options={this.state.filter.options}
                        placeHolder={this.state.filter.placeHolder}
                        filterElement={this.state.filter}
                        op={this.state.filterOperation}
                        value={this.state.value}
                        label={this.state.filterTagLabel}
                        onChangeValues={this.props.onChangeValues}
                    />
                );
            case 'date':
                return (
                    <DateFilter
                        id={this.state.filter.nameId}
                        type={this.state.filter.typeOfSelect}
                        filterElement={this.state.filter}
                        op={this.state.filterOperation}
                        value={this.state.value}
                        onDateSelected={this.props.onDateSelected}
                        onChangeValues={this.props.onChangeValues}
                        manageScroll={this.manageScroll}
                    />
                );

            case 'text':
                return (
                    <TextFilter
                        id={this.state.filter.nameId}
                        type={this.state.filter.typeOfSelect}
                        placeHolder={this.state.filter.placeHolder}
                        filterElement={this.state.filter}
                        op={this.state.filterOperation}
                        value={this.state.value}
                        onChangeValues={this.props.onChangeValues}
                    />
                );

            case 'number':
                return (
                    <NumberFilter
                        id={this.state.filter.nameId}
                        type={this.state.filter.typeOfSelect}
                        placeHolder={this.state.filter.placeHolder}
                        filterElement={this.state.filter}
                        op={this.state.filterOperation}
                        value={this.state.value}
                        onChangeValues={this.props.onChangeValues}
                    />
                );

            case 'boolean':
                return (
                    <BooleanFilter
                        id={this.state.filter.nameId}
                        op={this.state.filterOperation}
                        value={this.state.value}
                        onChangeValues={this.props.onChangeValues}
                    />
                );

        }
    }

    render() {
        return (

            <div key={this.props.filter.nameId + "card"} className="panel panel-default card pl-2 pr-2">
                <div ref={this.state.ref}></div>
                <div className='panelElem'>
                    <div className="card-heading flex flex-row" role="tab" id={this.props.filter.nameId + "filter"}>
                        <div className="panel-title mb-0">
                            <button className="btn collapsed" data-toggle="collapse" data-parent={"#" + this.props.parentName}
                                href={"#collapse" + this.state.filter.nameId + "filter"} onClick={this.collapseAction}>

                                {!this.state.display ? <Icon value={'chevron-right'} /> : <Icon value={'chevron-down'} />}
                                <span>{this.state.filter.label}</span>

                            </button>


                            {(!this.state.display && this.state.isUsed) ?
                                <span className="badge badge-primary ml-2 mb-2 badgeFilter"> {this.state.filter.label + " " + this.props.intl.formatMessage(messages[this.state.filterOperation]) + " " + this.state.filterTagLabel}</span> :
                                ''
                            }
                        </div>
                    </div>
                    <div id={"collapse" + this.props.filter.nameId + "filter"} className="panel-collapse collapse in" role="tabpanel">
                        <div className="panel-body">
                            <div className="mb-4">
                                {this.returnFilter()}
                            </div>

                        </div>
                    </div>
                </div>

            </div>


        );
    }
}
export default injectIntl(IndividualFilter);


// WEBPACK FOOTER //
// ./src/common/search-filter/filters-type/individualFilter.component.jsx